// CANONICAL COPY (GH #7115). src/constants/obligations/obl-processor-dsr-assistance.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-processor-dsr-assistance',
  title: 'Verify processor procedures to assist controllers with data-subject rights',
  description:
    'Confirm that the processor has written procedures to assist controllers in responding to data-subject requests — access, rectification, erasure, restriction, portability, objection and information duties — and that the underlying systems and databases support timely execution (GDPR Art. 28(3)(e); FSR ISAE 3000 Kontrolmål H.1–H.2). Procedures shall define intake channels from controllers, turnaround times, technical capabilities per system, and records of assistance provided per controller request. Review the DSR-assistance standard, sample controller requests handled and the annual procedure-review record.',
  category: 'compliance',
  scfIds: ['SCF-PRV-003'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'Processor DSR-assistance procedure is published' },
    { type: 'document-within-sla', description: 'Procedure review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
